import { render, staticRenderFns } from "./BuckSandbox.vue?vue&type=template&id=65841726&"
import script from "./BuckSandbox.vue?vue&type=script&lang=ts&"
export * from "./BuckSandbox.vue?vue&type=script&lang=ts&"
import style0 from "./BuckSandbox.vue?vue&type=style&index=0&id=65841726&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports